import { PharmacieService } from './../../../service/pharmacie.service';
import { GlobalService } from './../../../service/global.service';
import { PharmacieDto } from './../../../DTO/pharmacie.dto';
import { Component, OnInit } from '@angular/core';
import { OrdonnanceService } from 'src/app/service/ordonnance.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { OrdonnanceDto } from 'src/app/DTO/ordonnance.dto';
import { EnumEtats } from 'src/app/enum/enum.etat';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-ordonnance-list',
  templateUrl: './ordonnance-list.component.html',
  styleUrls: ['./ordonnance-list.component.scss']
})
export class OrdonnanceListComponent implements OnInit {

  ordonnances: OrdonnanceDto[] = [];
  nbPages = 1;

  public afficherPatientInformations = false;
  clickMessage: string;
  selectedOrdonnance: any;
  etat: string;

  headers = ["Etat","Visuel","Patient","Action sur l'ordonnance","Message au patient","Depuis", "Source de l\'envoi"];

  public imageAAfficher: string;
  public afficherImage: boolean = false;
  public images: string[];
  public extensions: string[];
  public index: number;
  public afficherOrdonnanceEtat: boolean = false;
  public enumEtats = EnumEtats;
  public pharmacie: PharmacieDto;
  public isPharmacieActive : boolean;
  public pharmacieActifSouscription : any;

  constructor(
    public ordonnanceService: OrdonnanceService,
    public globalService: GlobalService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    this.pharmacie = this.globalService.pharmacie;
    this.isPharmacieActive = this.pharmacie.actif;
    this.pharmacieActifSouscription = this.globalService.getPharmacieActifEmitter().subscribe(actifStatut => this.isPharmacieActive = actifStatut );
    this.refreshOrdonnancesList();
  }

  ngOnDestroy() {
    this.pharmacieActifSouscription.unsubscribe();
  }

  refreshOrdonnancesList() {
    this.ordonnances = [];
    this.ordonnanceService.getOrdonnancesMe('5', this.getCurrentPage().toString()).subscribe(ordonnance => {
      this.ordonnances.push(ordonnance);
      this.nbPages = this.ordonnanceService.metaOrdonnancesList.totalPages;
    }, (err: HttpErrorResponse) => {
      this.goToFirstPage();
    }, () => {
      this.ordonnanceService.isDataLoaded = true;
    });
  }

  afficherModalInformationsPatient(ordonnance) {
    this.selectedOrdonnance = ordonnance;
    this.afficherPatientInformations = true;
  }

  changeAfficherPatientInformation(event){
    this.afficherPatientInformations = event;
  }

  downloadPDF(ordonnance: OrdonnanceDto) {
    const downloadLink = document.createElement('a');
    for (let i = 0; i < ordonnance.images.length; i++) {
      let linkSource: string;
      let fileName: string;
      let extension: string;
      if (ordonnance.extensions[i] === 'pdf') {
        linkSource = 'data:application/pdf;base64,' + ordonnance.images[i];
        extension = '.pdf';
      } else {
        linkSource = 'data:image/jpg;base64,' + ordonnance.images[i];
        extension = '.jpg';
      }
      fileName = 'ordonnance - ' + ordonnance.nom + ' - ' + 'page ' + (i + 1) + extension;
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
    }
  }


  afficherImageModal(images: string[], extensions: string[], index) {
    this.images = images;
    this.extensions = extensions;
    this.index = index;
    this.afficherImage = true;
  }

  setImageModalState(event) {
    this.afficherImage = event;
  }

  afficherOrdonnanceTraiteeModal(ordonnance: OrdonnanceDto) {
    this.selectedOrdonnance = ordonnance;
    this.etat = EnumEtats.TRAITEE;
    this.setOrdonnanceStateModalState(true);
  }

  afficherOrdonnanceRejeteeModal(ordonnance: OrdonnanceDto) {
    this.selectedOrdonnance = ordonnance;
    this.etat = EnumEtats.REJETEE;
    this.setOrdonnanceStateModalState(true);
  }

  afficherOrdonnanceQuestionModal(ordonnance: OrdonnanceDto) {
    this.selectedOrdonnance = ordonnance;
    this.etat = EnumEtats.ENCOURS;
    this.setOrdonnanceStateModalState(true);
  }

  setOrdonnanceStateModalState(event) {
    this.afficherOrdonnanceEtat = event;
  }

  isOrdonnanceActionAuthorize(ordonnance: OrdonnanceDto) {
    return ordonnance.etat === EnumEtats.ENCOURS || ordonnance.etat === EnumEtats.ATRAITER
  }

  getMessageState(ordonnance: OrdonnanceDto) {
    const ordonnanceDateFormat = formatDate(ordonnance.dateMaj, 'dd/MM/yyyy', 'fr-FR') + " à " + formatDate(ordonnance.dateMaj, 'HH', 'fr-FR') + 'h' + formatDate(ordonnance.dateMaj, 'mm', 'fr-FR');
    if (ordonnance.etat === EnumEtats.REJETEE) {
      return "L'ordonnance a été rejetée le " + ordonnanceDateFormat;
    } else if (ordonnance.etat === EnumEtats.TRAITEE) {
      return "L'ordonnance a été traitée le " + ordonnanceDateFormat;
    }
  }

  printOrdonnance(image: string) {
    const WindowPrt = window.open('', '', 'top=0,left=0,height=100%,width=auto');
    WindowPrt.document.write(`
      <html>
        <head>
          <title>Impression ordonnance</title>
          <style>
            img {
              border-style: none;
              height: auto;
              max-width: 100%;
            }
          </style>
        </head>
        <body>
          <img src="data:image/jpg;base64,${image}" />
        </body>
      </html>
    `);
    WindowPrt.document.close();
    WindowPrt.focus();
    WindowPrt.print();
    WindowPrt.close();
  }

  getPaginationArray(numberDisplay: number) {
    const nbElementsInList = numberDisplay * 2 + 1;
    let res = [];

    if (+this.getCurrentPage() - numberDisplay < 1 ) {
      for (let i = 0; i <= nbElementsInList; i++) {
        res.push(i);
      }
    } else if(numberDisplay + +this.getCurrentPage() > this.nbPages) {
      for (let i = this.nbPages - nbElementsInList; i < this.nbPages; i++) {
        res.push(i+1);
      }
    } else {
      for (let i = 0 - numberDisplay; i <= numberDisplay; i++) {
        res.push(+this.getCurrentPage() + i);
      }
    }
    return res;
  }

  getCurrentPage() {
    let page: string;
    this.route.queryParams.subscribe(params => {
      page = params.page;
    });

    if (page === undefined) {
      return  1;
    } else {
      return page;
    }
  }

  goToFirstPage() {
    if (this.ordonnanceService.isDataLoaded) {
      this.router.navigate(
        [],
        {
          relativeTo: this.route,
          queryParams: { page: '1' },
          queryParamsHandling: 'merge'
        }).then(() => this.refreshOrdonnancesList());
    }
  }

  goToLastPage() {
    if (this.ordonnanceService.isDataLoaded) {
      this.router.navigate(
        [],
        {
          relativeTo: this.route,
          queryParams: { page: this.nbPages },
          queryParamsHandling: 'merge'
        }).then(() => this.refreshOrdonnancesList());
    }
  }

  goToBeforePage() {
    if (+this.getCurrentPage() > 1 && this.ordonnanceService.isDataLoaded) {
      this.router.navigate(
        [],
        {
          relativeTo: this.route,
          queryParams: { page: +this.getCurrentPage() - 1 },
          queryParamsHandling: 'merge'
        }).then(() => this.refreshOrdonnancesList());
    }
  }

  goToAfterPage() {
    if (+this.getCurrentPage() < this.nbPages && this.ordonnanceService.isDataLoaded) {
      this.router.navigate(
        [],
        {
          relativeTo: this.route,
          queryParams: { page: +this.getCurrentPage() + 1 },
          queryParamsHandling: 'merge'
        }).then(() => this.refreshOrdonnancesList());
    }
  }

  goToPageNumber(numPage: number) {
    if (this.ordonnanceService.isDataLoaded) {
      this.router.navigate(
        [],
        {
          relativeTo: this.route,
          queryParams: { page: numPage },
          queryParamsHandling: 'merge'
        }).then(() => this.refreshOrdonnancesList());
    }
  }

}


